module.exports = __webpack_public_path__ + "img/p006.b32d9482.png";